import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn_DIVER_G2 } from '../../models/TypeAnn_DIVER_G2';

@Component({
  selector: 'app-step6',
  templateUrl: './step6.component.html'
})
export class Step6Component implements OnInit {

  @Input() typeAnn_DIVER_G2: TypeAnn_DIVER_G2;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

  constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) { }

  ngOnInit(): void {
  }

  getUid() {
    return this.uid + '_SepSep_TypeAnn_DIVER_G2';
  }
}
